import { createContext, useContext } from 'react';
import { Theme } from '@mui/material/styles';
import turquoiseTheme from './turquoise';
import orinishikiTheme from './orinishiki';
import type { ThemeName } from '@/types';

export const themes: Record<ThemeName, Theme> = {
  turquoise: turquoiseTheme,
  orinishiki: orinishikiTheme,
};

export function getThemeFromUrl(): ThemeName {
  const params = new URLSearchParams(window.location.search);
  const theme = params.get('theme');
  if (theme === 'turquoise' || theme === 'orinishiki') {
    return theme;
  }
  return 'turquoise';
}

interface ThemeContextValue {
  themeName: ThemeName;
  setThemeName: (name: ThemeName) => void;
}

export const ThemeNameContext = createContext<ThemeContextValue>({
  themeName: 'turquoise',
  setThemeName: () => {},
});

export const useThemeName = () => useContext(ThemeNameContext);

export { turquoiseTheme, orinishikiTheme };
